import { Zap } from "lucide-react";

const ITEMS = [
  "Zero Trust Architecture",
  "MITRE ATT&CK Mapping",
  "SIEM / XDR Engineering",
  "SOAR Playbook Automation",
  "Threat Detection Engineering",
  "Security Operations Documentation",
  "Incident Response Design",
  "Operational Process Optimization",
];

export default function Marquee() {
  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden border-y border-white/5 bg-abyss/60 py-5"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div
            key={half}
            aria-hidden={half === 1}
            className="flex items-center gap-10 pr-10"
          >
            {ITEMS.map((item) => (
              <span
                key={item}
                className="flex items-center gap-3 whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.28em] text-slate-400"
              >
                <Zap className="h-3 w-3 text-cyan-400/70" />
                {item}
              </span>
            ))}
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
    </div>
  );
}
